import { Controller } from '@hotwired/stimulus'
import SFetch from '@app/utils/sfetch'

export default class extends Controller {
  static values = { dismissUrl: String }

  declare dismissUrlValue: string
  declare hasDismissUrlValue: boolean

  disconnect(): void {
    this.element.removeEventListener('transitionend', this.handleTransitionEnd)
  }

  async dismiss(event: Event): Promise<void> {
    event.preventDefault()

    if (this.hasDismissUrlValue) {
      try {
        await SFetch.json(this.dismissUrlValue, { method: 'PATCH' })
      } catch {
        return
      }
    }

    this.element.classList.add('dismissing')

    this.element.addEventListener('transitionend', this.handleTransitionEnd, {
      once: true,
    })
  }

  private handleTransitionEnd = (): void => {
    this.element.remove()
  }
}
